// extracted by mini-css-extract-plugin
module.exports = {"root":"cart-sidebar-cart-footer_root__5NR3q","summary":"cart-sidebar-cart-footer_summary__TUFTH","totalStrikethrough":"cart-sidebar-cart-footer_totalStrikethrough__jtWfZ"};